<template>
  <div style="overflow:auto;">
    <div class="nav-bar-container">
      <div class="clearfix nav-bar">
        <div class="welcome">
          <span class="summary-hello">{{ $t('hello') }}</span>
          <span class="summary-name">{{ renderedName }}</span>
          <span
            v-if="showTendersTable || showProjectsTable"
            class="summary-hello"
          >, {{ $t('hint.youHave') }}:</span>
        </div>

        <div class="summary-items">
          <div
            v-if="showTendersTable"
            class="summary-item"
            @click="scrollMeTo('tendersTable')"
          >
            <span class="summary-badge summary-badge__dark">{{ tenders.length }}</span>
            <span class="summary-item__title">{{ $t('dashboard.tendersInProgress') }}</span>
          </div>
          <div
            v-if="showProjectsTable"
            class="summary-item"
            @click="scrollMeTo('projectsTable')"
          >
            <span class="summary-badge summary-badge__normal">{{ projectNumber }}</span>
            <span class="summary-item__title">{{ $t('dashboard.activeProjects') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showTendersTable"
      id="tendersTable"
    >
      <TendersTable
        :key="componentKey"
        :model.sync="tenders"
      />
    </div>
    <div
      v-if="showProjectsTable"
      id="projectsTable"
    >
      <ProjectsTable
        id="projectTable"
        :key="componentKey"
        :items.sync="projects"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ref, computed } from 'vue-demi'
import lodash from 'lodash'
import TendersTable from '@/modules/tenders/TendersTable.vue'
import ProjectsTable from '@/modules/projects/ProjectsTable.vue'
import { aclHelper } from '@/utils/aclHelper'
import EventBus from '@/utils/eventBus'
import CmsModulesStatusMixin from '@/modules/CmsModulesStatusMixin'
import SwitchRegionsEventMixin from '../modules/SwitchRegionsEventMixin'

export default {
  name: 'NonTenantProjectDashboard',
  components: {
    TendersTable,
    ProjectsTable,
  },
  mixins: [
    CmsModulesStatusMixin,
    SwitchRegionsEventMixin,
  ],
  setup () {
    const projects = ref([])
    const projectNumber = computed(() => {
      return lodash.get(projects, 'value.length', 0)
    })
    const scrollMeTo = (tableId) => {
      const top = document.getElementById(tableId).offsetTop
      $('html, body').animate({ scrollTop: top }, 200)
    }
    return {
      projects,
      projectNumber,
      scrollMeTo,
    }
  },
  data () {
    return {
      username: '',
      tenders: [],
      loadingTenderTable: false,
    }
  },
  computed: {
    ...mapGetters('regions', ['enableTenderFeature', 'enableProjectFeature']),
    ...mapGetters('user', ['currentUser']),
    renderedName () {
      return (this.currentUser && this.currentUser.name) || this.$i18n.t('hklandUser')
    },
    showTendersTable () {
      return this.enableTenderFeature && (this.isTenderAccess || this.isTenderRep)
    },
    showProjectsTable () {
      return this.enableProjectFeature && aclHelper.hasProjectsAccess()
    },
    isTenderAccess () {
      return aclHelper.hasTendersAccess()
    },
    isTenderRep () {
      return aclHelper.hasTenderRepAccess()
    },
  },
  mounted () {
    if (!this.showTendersTable && !this.showProjectsTable) {
      EventBus.emit('module_header_menu_open')
    }
  },
}
</script>

<style scoped src="styles/dashboard/style.scss"></style>
